import { User } from "~/common/Store/models/User";
import { PricingGroupMember } from "~/ProductDetails/Pricing/PricingProduct";
import shouldDisplayQuantityDiscounts from "~/common/Product/shouldDisplayQuantityDiscounts";
import getLowestDisplayPrice from "~/common/Product/getLowestDisplayPrice";

interface QuantityDiscount {
  endQuantity?: number;
  isLotDiscount: boolean;
  quantity: number;
  price: number;
  startQuantity: number;
}

interface Product {
  showBelowMinimumAdvertisedPriceForLoggedInCustomers: boolean;
  showBelowMinimumAdvertisedPriceForPlatinumAndPlusCustomers: boolean;
  startBuy: number;
  price: {
    minimumAdvertisedPriceProperties: {
      price: number;
      type: string;
    };
    minimumAdvertisedPriceOverride: {
      priceLevel5: number;
    };
    quantityDiscounts: QuantityDiscount[];
    displaySalePrice: boolean;
    saleStartDate?: string;
    saleEndDate?: string;
    salePrice: number;
    price: number;
    displayMinimumAdvertisedPrice: boolean;
  };
  groupingAttributes: {
    isVirtual: boolean;
    isGroupMaster: boolean;
    groupMembers: PricingGroupMember[];
  };
}

//
// We needed to perform this logic on the front-end because we needed user information.
//
export default (product: Product, user: User): boolean => {
  if (!product.groupingAttributes.isGroupMaster) {
    const lowestPrice = getLowestDisplayPrice(product, user, true, true);
    const [displayQuantityDiscounts] = shouldDisplayQuantityDiscounts(
      { ...product },
      lowestPrice,
      user,
    );
    return displayQuantityDiscounts;
  }

  const hasChildrenQuantityDiscounts =
    product.groupingAttributes.groupMembers.some((groupMember) => {
      const [displayQuantityDiscountsForGroupMember] =
        shouldDisplayQuantityDiscounts(
          {
            ...product,
            price: groupMember.price,
            startBuy: groupMember.startBuy,
          },
          getLowestDisplayPrice(product, user, true, true),
          user,
        );
      return displayQuantityDiscountsForGroupMember;
    });
  return hasChildrenQuantityDiscounts;
};
